import { createContext, useReducer } from 'react'
import { type EventProviderProps, type EventDataContextProps, type EventDispatchContextProps, type Event } from 'src/types'

import { reducer } from './reducer'
import { eventData as eventDataBackup } from 'src/data'

const eventData: Record<string, Event> = {}

eventDataBackup.forEach((entry) => {
  eventData[entry.id] = entry
})

export const EventDataContext = createContext<EventDataContextProps>({ events: eventData })
EventDataContext.displayName = 'EventDataContext'

export const EventDispatchContext = createContext<EventDispatchContextProps>({ dispatchEvents: () => null })
EventDispatchContext.displayName = 'EventDispatchContext'

export const EventProvider = ({ children }: EventProviderProps) => {
  const [events, dispatchEvents] = useReducer(reducer, eventData)
  return (
    <EventDataContext.Provider value={{ events }}>
      <EventDispatchContext.Provider value={{ dispatchEvents }}>
        {children}
      </EventDispatchContext.Provider>
    </EventDataContext.Provider>
  )
}
